module.exports = __webpack_public_path__ + "static/media/jzk.ee546e30.png";